import { apiRequest } from '@/utils/apiRequest'
import { apiUrl, extractCollection } from '@/utils/apiUrl'

class ServiceEventRepository {
	async getServiceEventsByDate(date, scope = 'pending') {
		const params = new URLSearchParams({ scope })
		if (date && date !== 'null' && date !== 'undefined') {
			params.set('date', date)
		}
		const url = apiUrl(`/world/api/service-events?${params.toString()}`)
		try {
			const response = await apiRequest({ url, method: 'GET', expect: 'json' })
			const data = response?.data ?? response
			return extractCollection(data)
		} catch (e) {
			console.error('Error fetching service events:', e)
			return []
		}
	}

	async claimServiceEvent({ serviceEventId, staffId }) {
		const url = apiUrl('/world/api/service-event/claim')
		try {
			const response = await apiRequest({
				url,
				method: 'POST',
				body: { serviceEventId, staffId },
				throwOnNonOk: false,
			})
			if (!response.ok) {
				return { result: -1, message: response?.data?.message || 'Error claiming service event' }
			}
			return response.data
		} catch (e) {
			console.error('Error claiming service event:', e)
			return { result: -1, message: e?.message || 'Error claiming service event' }
		}
	}
}

export const serviceEventRepository = new ServiceEventRepository()
